module.exports = __webpack_public_path__ + "img/17bc6ac.jpg";